export const FORMATTED_UPS_SERVICES_NAME = new Map([
    ['Ground', 'UPS® Ground'],
    ['3 Day Select', 'UPS 3 Day Select®'],
    ['2nd Day Air', 'UPS 2nd Day Air®'],
    ['2nd Day Air AM', 'UPS 2nd Day Air A.M.®'],
    ['Next Day Air Saver', 'UPS Next Day Air Saver®'],
    ['Next Day Air Early', 'UPS Next Day Air® Early'],
    ['Next Day Air', 'UPS Next Day Air®'],
]);
